import { render, staticRenderFns } from "./PositionDetails.vue?vue&type=template&id=7103e448&"
import script from "./PositionDetails.vue?vue&type=script&lang=js&"
export * from "./PositionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PositionDetails.vue?vue&type=style&index=0&id=7103e448&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports